module.exports = __webpack_public_path__ + "static/media/starOff_326.b79b6180.png";